export enum BusinessCategoryType {
  None = "None",
  Law = "Law",
  FinancialServices = "FinancialServices",
  BusinessSupply = "BusinessSupply"
}



// None,
//
//   Law,
//   FinancialServices,
//   PublicRelations,
//   Animals,
//   Laboratory,
//   Pharmaceutical,
//   Internet,
//   Industrial,
//
//   Design,
//   Mobile,
//   Music,
//   Jewellery,
//   Deliveries,
//   Security,
//
//   Accounting,
//   Advertising,
//   Automotive,
//   Broadcast,
//   Communications,
//   Construction,
//   Consulting,
//   Cosmetics,
//   Ecommerce,
//   Education,
//   Electronics,
//   Energy,
//   EntertainmentAndLeisure,
//   Flowers,
//   Finance,
//   Food,
//   KosherFood,
//   FastFood,
//   Clothing,
//   Government,
//   Grocery,
//   Gifts,
//   HealthCare,
//   HighTech,
//   Hospitality,
//   Insurance,
//   Legal,
//   Marketing,
//   Productions,
//   Photography,
//   Print,
//   Publicity,
//   RealEstate,
//   RetailAndWholesale,
//   TelecomService,
//   Transportation,
//   Toys,
//   Travel,
//   Other
